@let form = this.form();
<div class="container-xl">
    <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>
    @if (form) {
        <form [formGroup]="form" class="row gap-3" id="user-form">
            <div class="col">
                <div class="row">
                    <div class="col-3">
                        <b>Soort</b>
                        <ng-select [items]="leaveTypes()"
                                   [searchable]="true"
                                   bindLabel="name"
                                   bindValue="key"
                                   formControlName="leave_type"
                                   placeholder="Kies een verlofsoort">
                            <ng-template ng-option-tmp let-item=item>
                                <span>{{item.name}}</span>
                                <small>{{item.description}}</small>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col">
                        <b>Opmerking</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="comment" matInput placeholder="Opmerking" type="text">
                                <mat-error [control]="form.controls.comment"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Publieke opmerking</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="public_comment" matInput placeholder="Publieke opmerking" type="text">
                                <mat-error [control]="form.controls.public_comment"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                @if (Roles.Management | hasRole) {
                    <div class="row">
                        <div class="col-auto d-flex align-items-center">
                            <div class="form-check">
                                <input class="form-check-input" formControlName="common" id="common" type="checkbox">
                                <label class="form-check-label" for="common">Bedrijfsbreed</label>
                            </div>
                        </div>
                        <div class="col">
                            @if (!form.getRawValue().common) {
                                <ng-select
                                    [clearSearchOnAdd]="true"
                                    [clearable]="true"
                                    [closeOnSelect]="false"
                                    [items]="users()"
                                    [multiple]="true"
                                    bindLabel="name"
                                    bindValue="id"
                                    class="ng-select-fill"
                                    formControlName="users"
                                    placeholder="Medewerkers">
                                    <ng-template ng-notfound-tmp>
                                        @if (form.value.leave_type) {
                                            <div class="ng-option disabled">Geen medewerkers gevonden</div>
                                        } @else {
                                            <div class="ng-option disabled">Kies eerst een verlofsoort</div>
                                        }
                                    </ng-template>
                                </ng-select>
                            }
                        </div>
                    </div>
                }
                <div class="row">
                    @if (form.value.interval) {
                        <div class="col-12">
                            <b>
                                Periode
                                <i
                                    class="fa fa-info-circle"
                                    matTooltip="De periode waarbinnen herhaalt wordt.
                           Als de begintijd van de periode later is dan de begintijd bij 'Tijden', is op de eerste dag de begintijd van de periode leidend. Vice versa voor eindtijd."
                                    matTooltipPosition="above"></i>
                            </b>
                            <div class="row">
                                <div class="col">
                                    <app-datetime-input
                                        [matFormField]="true"
                                        [min]="minDate"
                                        formControlName="begindate"
                                        labelDate="Begindatum"
                                        labelTime="tijd"></app-datetime-input>
                                    <mat-error [control]="form.controls.begindate"></mat-error>
                                </div>
                                <div class="col">
                                    <app-datetime-input
                                        [matFormField]="true"
                                        [max]="maxDate"
                                        [min]="form.controls.begindate.value"
                                        formControlName="enddate"
                                        labelDate="Einddatum"
                                        labelTime="tijd"></app-datetime-input>
                                    <mat-error [control]="form.controls.enddate"></mat-error>
                                </div>
                            </div>
                        </div>
                    } @else {
                        <div class="col-12 col-md-4">
                            <b>Datum</b>
                            <div>
                                <mat-form-field>
                                    <input
                                        (focus)="pickerStart.open()"
                                        [matDatepicker]="pickerStart"
                                        [min]="minDate"
                                        formControlName="begindate"
                                        matInput placeholder="Datum">
                                    <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                    <mat-datepicker #pickerStart></mat-datepicker>
                                    <mat-error [control]="form.controls.begindate"></mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    }
                    <div class="col-6">
                        <b>
                            {{form.value.interval ? 'Tijden' : 'Tijd'}}
                            @if (form.value.interval) {
                                <i
                                    class="fa fa-info-circle"
                                    matTooltip="De tijd op de dag zelf.
                           Als de begintijd onder 'Periode' later is is dan deze begintijd, is op de eerste dag de begintijd van de periode leidend. Vice versa voor eindtijd."
                                    matTooltipPosition="above"></i>
                            }
                        </b>
                        <div class="row">
                            <div class="col-6">
                                <app-datetime-input
                                    [hideDate]="true"
                                    [matFormField]="true"
                                    formControlName="begintime"
                                    labelDate="Begindatum"
                                    labelTime="tijd"></app-datetime-input>
                                <mat-error [control]="form.controls.begintime"></mat-error>
                            </div>
                            <div class="col-6">
                                <app-datetime-input
                                    [hideDate]="true"
                                    [matFormField]="true"
                                    formControlName="endtime"
                                    labelDate="Einddatum"
                                    labelTime="tijd"></app-datetime-input>
                                <mat-error [control]="form.controls.endtime"></mat-error>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 d-flex align-items-center">
                        Duur: {{duration | minutes}} uur
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto d-flex align-items-center">
                        <mat-checkbox formControlName="interval">
                            Herhalend
                        </mat-checkbox>
                    </div>
                    @if (form.value.interval) {
                        <mat-form-field class="col">
                            <mat-label>Week interval</mat-label>
                            <input appDecimalInput
                                   formControlName="interval_week"
                                   matInput
                                   placeholder="Week interval  (1 = wekelijks, 2 = iedere 2 weken)"
                                   type="text">
                            <mat-error [control]="form.controls.interval_week"></mat-error>
                        </mat-form-field>
                    }
                </div>
                @if (form.value.interval) {
                    <div>
                        <mat-checkbox color="primary" formControlName="repeat_monday">Maandag</mat-checkbox>
                        <br>
                        <mat-checkbox color="primary" formControlName="repeat_tuesday">Dinsdag</mat-checkbox>
                        <br>
                        <mat-checkbox color="primary" formControlName="repeat_wednesday">Woensdag</mat-checkbox>
                        <br>
                        <mat-checkbox color="primary" formControlName="repeat_thursday">Donderdag</mat-checkbox>
                        <br>
                        <mat-checkbox color="primary" formControlName="repeat_friday">Vrijdag</mat-checkbox>
                        <br>
                        <mat-checkbox color="warn" formControlName="repeat_saturday">Zaterdag</mat-checkbox>
                        <br>
                        <mat-checkbox color="warn" formControlName="repeat_sunday">Zondag</mat-checkbox>
                    </div>
                }
            </div>
            <div class="col-md-3 results-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th>
                                Resulterende datums
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (preview of previewRealisations(); track preview.from && preview.till) {
                            <tr>
                                <td class="text-right">
                                    {{preview.from | date :'EEE d MMM yyyy HH:mm'}} tot {{preview.till | date :'HH:mm'}}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </form>
    }
</div>

@if (registrations()?.length > 0) {
    <div class="container-xl mt-2">
        <div class="d-flex justify-content-center">
            <table class="table table-striped table-hover realisations">
                <thead>
                    <tr>
                        <th>Startdatum</th>
                        <th>Einddatum</th>
                        <th>Medewerker</th>
                        <th>Goedgekeurd</th>
                    </tr>
                </thead>
                @for (realisation of registrations(); track realisation.id) {
                    <tr>
                        <td>{{realisation.starttime | date : 'EEE d MMM yyyy HH:mm'}}</td>
                        <td>{{realisation.endtime | date : 'EEE d MMM yyyy HH:mm'}}</td>
                        <td>{{realisation.user_id | userName: users()}}</td>
                        <td>{{realisation.approved_at | date : 'EEE d MMM yyyy HH:mm'}}</td>
                    </tr>
                }
            </table>
        </div>
    </div>
}

<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            <button [routerLink]="['/', Routenames.leave]" class="btn btn-secondary w-100">
                Naar overzicht
            </button>
            @if (form && canSaveLeave) {
                <button (click)="save()" [disabled]="!form.dirty" class="btn btn-primary w-100">
                    {{saved ? 'Wijzigingen opgeslagen' : form.dirty ? 'Openstaande wijzigingen opslaan' : 'Er zijn geen wijzigingen'}}
                    @if (saving) {
                        <i class="fas fa-spinner fa-spin"></i>
                    }
                </button>
            }
        </div>
    </div>
</div>
